import { makeStyles } from "@material-ui/core/styles";

// icons removed (not used in this component)
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';
import notify from '../../../utils/notifier';
import ConfirmUpdateDialog from '../../configuration/ConfirmUpdateDialog';
import { toast } from 'react-toastify';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, CircularProgress } from '@material-ui/core';
import { useHistory, useParams, useLocation } from "react-router-dom";
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import authUtil from "../../../utils/AuthUtils";

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      minHeight: '100vh',
      overflow: 'auto',
      backgroundColor: '#F8F9FB',
      paddingBottom: 40
    },
    grid: {
      display: 'flex',
      overflow: 'auto'
    },

    contentPage:{
        padding:'32px',
        backgroundColor: 'white',
        color:'black'
    },
    card: {
      borderRadius: 8,
      border: '1px solid #DDE5EC',
      boxShadow: 'none',
      background: '#FFFFFF',
      maxWidth: 900,
      margin: '0 auto',
      overflow: 'hidden'
    },
    blueTitleBar: {
      background: '#CBE4F5',
      height: 44,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 16,
      fontWeight: 600,
      color: '#1E3A5F',
      fontSize: 16,
      textTransform: 'uppercase',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8
    },
    formSection: {
      padding: 24
    },
    sectionTitle: {
      fontWeight: 600,
      marginBottom: 16
    },
    fieldInputFull: {
      width: '100%'
    },
    fieldBox: {
      marginBottom: 20
    },
  
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 2,
      mb: 2 
    },
  
    backButton:{
      padding: 0,
      minWidth: 'auto',
      fontSize: '0.8rem',
      textTransform: 'none',
      fontFamily: 'PilatLight',
      marginBottom: '12px'
    },
  
    title:{
      fontFamily: 'PilatWideHeavy', 
      textTransform: 'none',
      fontWeight: 'bold',
      fontSize: '32px'
    },
  
    updateButton:{
      backgroundColor: '#00445D',
      borderRadius: 24,
      textTransform: 'none',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#00374C',
      },
      padding: '8px 22px',
      height: 36,
      fontSize: 14,
      fontWeight: 500
    },

    cancelButton:{
        backgroundColor: '#fff',
        borderRadius: '18px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#fff',
        },
        width:'77px',
        height: '36px',
        fontSize: '12px' 
    },

    textField:{
      borderRadius: '10px',
      color: '#666',
      fontSize: '0.9rem',
      paddingTop : 0,
      paddingBottom : 2,
      height: '36px',
      width:'300px'
    },
  
    searchIcon:{
      fontSize: 20, color: '#888'
    },
  
    controlContainer:{
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },

    whiteRow:{
      backgroundColor: '#fff',
      height:'30px'
    },

    coloredRow:{
      backgroundColor: '#F9FCFF',
      height:'30px'
    },

    boldCell:{
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#1E1450',
        borderBottom: '1px solid #444',
        textAlign: 'left',
        paddingTop: 0.5, paddingBottom: 0.5 
    },
  
    cell:{
      fontSize: '14px',
      color: '#1E1450',
      borderBottom: '1px solid #444',
      textAlign: 'left',
      paddingTop: 0.5, paddingBottom: 0.5 
    },

    table:{
      '& .MuiTableRow-root': {
          height: '40px',
      }
    },

    deletedRow: {
      backgroundColor: '#ffebee',
      textDecoration: 'line-through',
      opacity: 0.6
    },

    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '200px'
    }
}));

function UpdateFolder() {
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documentTypeId, setDocumentTypeId] = useState('');
  const classes = useStyles();
  const history = useHistory();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const location = useLocation(); // Add this to track location changes
  const { id } = useParams();
  
  console.log('Current ID:', id);
  console.log('Current location:', location.pathname);

  const fetchDocumentTypeDetails = React.useCallback(async () => {
    try {
      console.log('Fetching document type details for ID:', id);
      setLoading(true);

      // Use service layer instead of direct fetch
      const data = await DocuwareTemplateService.fetchDocumentTypeDetails(id);
      console.log('Received data:', data);

      // Set the document type details based on actual API response structure
      setName(data.client_name || data.name || '');
      setDescription(data.description || ''); // Add description if it exists in API response
      setDocumentTypeId(id);

      // Convert the response data to table format - use 'metadata' array from API
      const formattedData = data.metadata?.map(field => ({
        fieldName: field.metadata_key,
        fieldType: field.field_type || field.type || 'String', // Default to String if no type
        isMandatory: field.is_mandatory || false,
        searchable: field.searchable || false,
        isDeleted: false,
        isModified: false,
        isNew: false
      })) || [];

      console.log('Formatted data:', formattedData);
      setTableData(formattedData);
      setOriginalData(JSON.parse(JSON.stringify(formattedData)));

    } catch (error) {
      console.error('Error fetching document type details:', error);
      notify({
        type: 'error',
        message: `Error fetching document type details: ${error.message}`
      });
    } finally {
      setLoading(false);
    }
  }, [id]);

  // Reset state when component mounts or ID changes
  useEffect(() => {
    console.log('UseEffect triggered - ID:', id, 'Location:', location.pathname);

    // Only proceed if we have an ID
    if (!id) {
      console.log('No ID provided, skipping fetch');
      return;
    }

    // Reset relevant state when navigating to a new ID
    setName('');
    setDescription('');
    setTableData([]);
    setOriginalData([]);
    setDocumentTypeId('');

    // Fetch new data
    fetchDocumentTypeDetails();
  }, [id, location.pathname, fetchDocumentTypeDetails]); // Add location.pathname & callback to dependencies

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  // table/field helper functions removed (not used in simplified edit UI)

  const handleUpdateButton = async () => {
    // Open confirm dialog before proceeding
    setConfirmOpen(true);
  };

  const handleConfirmUpdate = async () => {
    setConfirmOpen(false);
    try {
      const user = authUtil.getClientInfo();
      const updates = [];

      // Process existing fields for updates and deletions
      tableData.forEach((row, index) => {
        const original = originalData[index];
        
        if (row.isDeleted) {
          updates.push({
            metadata_key: row.fieldName,
            delete: true
          });
        } else if (row.isModified && original) {
          updates.push({
            metadata_key: row.fieldName,
            is_mandatory: row.isMandatory,
            searchable: row.searchable
          });
        } else if (row.isNew) {
          updates.push({
            metadata_key: row.fieldName,
            is_mandatory: row.isMandatory,
            searchable: row.searchable,
            field_type: row.fieldType,
            is_new: true
          });
        }
      });

      const nameToUpdate = name;

      // Prepare request for updating the folder metadata and details
      const requestObj = {
        user: user,
        document_type_id: documentTypeId,
        updates: updates,
        details: {
          name: name,
          description: description
        }
      };

      // Call the service to perform the update - use bulkUpdateMetadata for metadata
      await DocuwareTemplateService.bulkUpdateMetadata(requestObj);

      // Show custom styled success toast
      toast.success(`'${nameToUpdate}' folder updated successfully.`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 4000,
        icon: <CheckCircleIcon style={{ color: '#2E7D32' }} />,
        style: {
          background: '#E9F9E9',
          border: '1px solid #9BD59B',
          color: '#2E7D32',
          padding: '12px 20px',
          borderRadius: 6,
          fontWeight: 500
        }
      });

      // navigate to storage list
      handleHomeClick();

    } catch (error) {
      console.error('Error updating document type:', error);
      notify({
        type: 'error',
        message: `Error updating the document type: ${error.message}`
      });
    }
  };

  const handleHomeClick = () => {
    history.push('/document-suite/configurations/storage');
  };

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div style={{ marginRight: '40px' }}>
        <div style={{ marginBottom: '20px' }}>
          <div sx={{ padding: '1rem 0' }}>
            <Button
              onClick={handleHomeClick}
              startIcon={<ArrowBackIcon />}
              className={classes.backButton}
            >
              Back to Storage
            </Button>

            <Box className={classes.titleContainer}>
              <Typography variant="h4" className={classes.title}>
                EDIT FOLDER
              </Typography>

              <div className={classes.controlContainer}>
                <Button variant="contained" className={classes.cancelButton} onClick={handleHomeClick}>
                  Cancel
                </Button>
                <Button variant="contained" className={classes.updateButton} onClick={handleUpdateButton}>
                  Update
                </Button>
              </div>
            </Box>
          </div>
        </div>

        <div className={classes.contentPage}>
          <div>
            <div>Name*</div>
            <TextField
              placeholder="Name"
              value={name}
              onChange={handleNameChange}
              variant="outlined"
              size="small"
              InputProps={{
                className: classes.textField,
              }}
            />
          </div>

          <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <div>Description</div>
            <TextField
              placeholder="Description"
              value={description}
              onChange={handleDescriptionChange}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                className: classes.fieldInputFull,
              }}
            />
          </div>
        </div>

        <ConfirmUpdateDialog open={confirmOpen} onClose={() => setConfirmOpen(false)} onConfirm={handleConfirmUpdate} folderName={name} />
      </div>
    </div>
  );
}

export default UpdateFolder;